import { render, staticRenderFns } from "./MeritoPage.vue?vue&type=template&id=3038866c"
import script from "./MeritoPage.js?vue&type=script&lang=js&external"
export * from "./MeritoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports